//Procces is not defined, how to solve this?

export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
export const MEDIA_URL =
  process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000';
